import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { UserContext } from "../../../../../Context/UserContextAPI";
import BarCodeInInvoice from "../../../Invoice/components/BarCodesInInvoice";
import UserInfoTable from "../Components/UserInfoTable";
import StaticContentInReport from "../Components/StaticContentInReport";
import { useQuery } from "@tanstack/react-query";
import request from "../../../../../utils/request";
import { format } from "date-fns";
import LoaderLayout from "../../../../../components/Layout/LoaderLayout";
import VaccineTable from "./VaccineTable";
import useQueryFetch from "../../../../../hooks/useQueryFetch";
import { Table } from "react-bootstrap";
import SignatureInReports from "../Components/SignatureInReports";

const PrintVaccineCertificate = ({ noHeader, user_id }) => {
  let { userId } = useParams();
  userId = user_id ? user_id : userId;
  const { currentUser, accessPerm, settingsData } = useContext(UserContext);

  const { data: userData, isLoading } = useQuery({
    queryKey: ["user", userId],
    queryFn: async () => {
      const res = await request.getOne("user-details/test", userId);
      return res.status === "OK" ? res.data : null;
    },
  });
  const userDetail = userData?.userDetail;
  const user = userData?.userDetail?.user;

  const { data: vaccineTests } = useQueryFetch(
    ["vaccineTests", userId],
    () => request.getOne("reports/vaccine/reports", userId),
    {
      placeholderData: [],
    },
  );

  const urlWithBase64ID = settingsData?.qrcode_url;

  return (
    <LoaderLayout isPending={isLoading}>
      <section className="held-up-certificate d-flex flex-column justify-content-between ">
        <div className="row align-items-center">
          <img
            src={`${process.env.REACT_APP_UPLOAD_URL}/${settingsData?.header_image}`}
            alt="Report Header"
            className="mx-auto"
            style={{
              width: "100%",
              visibility: noHeader ? "hidden" : "visible",
            }}
          />
        </div>
        <div className="">
          {/* Empty div to take up the left space */}

          {/* Medical Form centered */}
          <div
            className="text-center text-uppercase text-dark fs-5"
            style={{ textDecoration: "underline", fontWeight: "bolder" }}
          >
            Medical Vaccine Report
          </div>
        </div>

        <div className="d-flex justify-content-between fw-bolder">
          <div>
            <p className="fs-6">
              Reg No : {user?.reg_prefix}
              {user?.registration_no}{" "}
            </p>
          </div>
          <div>
            <p className="fs-6">
              Reg Date :{" "}
              {user?.createdAt
                ? format(new Date(user?.createdAt), "dd-MM-yyyy hh:mm a")
                : "---"}{" "}
            </p>
          </div>
        </div>

        {/* bar code  */}
        <BarCodeInInvoice userDetail={userDetail} />
        <UserInfoTable
          user={user}
          userDetails={userDetail}
          // physicalData={physicalData}
        />

        <StaticContentInReport settingsData={settingsData} />

        <Table bordered className="border-dark mt-3">
          <thead>
            <tr>
              <th>Vaccine Name</th>
              <th>Result</th>
            </tr>
          </thead>
          <tbody>
            {vaccineTests?.map((test, index) => (
              <tr key={index}>
                <td>{test?.name}</td>
                <td>{test?.result}</td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className=" medical-xray-print">
          <SignatureInReports
            urlWithBase64ID={urlWithBase64ID}
            currentUser={currentUser}
          />

          <div className="d-flex justify-content-end gap-2 heldup-button mt-2">
            {accessPerm(33, 30) && (
              <button
                className="btn btn-primary"
                onClick={() => window.print()}
              >
                Print
              </button>
            )}

            <button
              className="btn btn-outline-secondary"
              onClick={() => {
                window.close();
              }}
            >
              Close
            </button>
          </div>
        </div>
      </section>
    </LoaderLayout>
  );
};

export default PrintVaccineCertificate;
